module.exports = __webpack_public_path__ + "img/sld_scb_40_t1_b1_green.49137ff3.svg";